import styled from 'styled-components';
import colors from 'styles/colors';

export const Section = styled.div`
  border-bottom: 1px solid ${colors.gray80};
  padding-bottom: 35px;
  margin-bottom: 20px;

  &:last-child {
    border: 0;
  }
`;

export const Description = styled.p`
  font-size: 12px;
  line-height: 17px;
  margin-top: 12px;
  margin-bottom: 16px;
`;
